import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CompanySettingsTab from './CompanySettingsTab'
import SystemSettingsTab from './SystemSettingsTab'
import PasswordChangeTab from './PasswordChangeTab'
import ProductsTab from './ProductsTab'

const Settings = () => {
	const { t } = useTranslation()
	const [searchParams] = useSearchParams()
	const [activeTab, setActiveTab] = useState('company')

	useEffect(() => {
		const tab = searchParams.get('tab')
		if (tab && ['company', 'system', 'password', 'products'].includes(tab)) {
			setActiveTab(tab)
		}
	}, [searchParams])

	const tabs = [
		{ name: t('settingsPage.tabs.company'), key: 'company' },
		{ name: t('settingsPage.tabs.system'), key: 'system' },
		{ name: t('settingsPage.tabs.password'), key: 'password' },
		{ name: t('settingsPage.tabs.products'), key: 'products' }
	]

	const renderTabContent = () => {
		switch (activeTab) {
			case 'company':
				return <CompanySettingsTab />
			case 'system':
				return <SystemSettingsTab />
			case 'password':
				return <PasswordChangeTab />
			case 'products':
				return <ProductsTab />
			default:
				return <CompanySettingsTab />
		}
	}

	return (
		<main>
			<header className="border-b border-gray-200 bg-white rounded-t-lg">
				<nav className="flex overflow-x-auto py-4">
					<ul
						role="list"
						className="flex min-w-full flex-none gap-x-6 px-4 text-sm/6 font-semibold text-gray-500 sm:px-6 lg:px-8">
						{tabs.map(tab => (
							<li key={tab.name}>
								<button
									onClick={() => setActiveTab(tab.key)}
									className={activeTab === tab.key ? 'text-indigo-600' : 'hover:text-gray-700'}>
									{tab.name}
								</button>
							</li>
						))}
					</ul>
				</nav>
			</header>

			<div className="divide-y divide-gray-200 bg-white rounded-b-lg">
				{renderTabContent()}
			</div>
		</main>
	)
}

export default Settings
